import { useQuery, useMutation } from 'react-query'
import API from '.'
import { serializeQuery } from './utils'

const ENDPOINT = '/api/cp-58'
const QUERY_KEY = 'cp-58'

export const useGetCP58 = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'list', query],
    async () => (await API.get(serializeQuery(ENDPOINT, query))).data,
    config
  )

export const usePostGenerateCP58 = (config = {}) =>
  useMutation((body) => API.post(`${ENDPOINT}/generate`, body), config)

export const usePostImportPopulateCP58 = (config = {}) =>
  useMutation(
    (body) => API.post(`${ENDPOINT}/import/populate`, body, { responseType: 'blob' }),
    config
  )

export const usePostExportCP58 = (config = {}) =>
  useMutation((body) => API.post(`${ENDPOINT}/export`, body, { responseType: 'blob' }), config)

export const useDeleteCP58 = (config = {}) =>
  useMutation((id) => API.delete(`${ENDPOINT}/${id}`), config)
